import styled from '@emotion/styled';
import type { FeedbackIconProps } from '../FeedbackIconTypes';

export interface SvgIconProps extends FeedbackIconProps {
  color: string;
}

export const SvgIcon = styled.svg<SvgIconProps>`
  ${({ size }) => `
  height: ${size};
  width: ${size};
  `}
  ${({ color }) => `fill: ${color};`}
  stroke: none;
`;
